/* eslint-disable max-len */
import { useContext } from 'react';
import { MainContext } from '../contexts';

export const useTranslations = (translations = {}, defaultLang = 'ES'): Record<string, any> => {
  const { lang = defaultLang } = useContext(MainContext);

  return Object.keys(translations[lang]).reduce((accum, t) => (
    { ...accum, [t]: translations[lang][t] }), {}
  );
};
